import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import {
  Accordion,
  Box,
  ConditionalWrapper,
  Heading,
  Image,
  Text,
  useMediaQuery,
  Wrapper,
} from '@lounge-fe/ui-kit'

import { MediaAccordionData } from './types'
import Media from '@/pages/Product/Media'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

export const MediaAccordion: ShopifySectionComponent<MediaAccordionData> = ({
  data,
}) => {
  const { getFlag } = useFeatureFlags()
  const isDesktop = useMediaQuery(({ screens }) => `(min-width: ${screens.sm})`)

  const { accordionItems, spacer } = data!

  return (
    <ConditionalWrapper
      condition={isDesktop}
      wrapper={(children) => <Wrapper>{children}</Wrapper>}
    >
      <Accordion
        variant="icon"
        iconPosition="end"
        disableToggle
        className={'flex flex-col gap-2 md:flex-row ' + spacer}
        keepMounted={getFlag('keep_accordion_content_mounted')}
      >
        {({ openItems }) => (
          <>
            {accordionItems.map((accordion, i) => {
              const { image, placeholderImage } = accordion

              return (
                parseInt(openItems[0]) === i && (
                  <div key={i} className="md:basis-1/2">
                    <AnimatePresence>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.42, ease: 'easeInOut' }}
                        className="h-full"
                      >
                        {image ? (
                          <Image
                            data={{
                              src: image.src,
                              width: 700,
                            }}
                            alt={image.alt}
                            className="w-full h-full object-cover aspect-[18/11]"
                          />
                        ) : (
                          <Box
                            className="bg-surface-secondary-default h-full w-full aspect-[18/11]"
                            dangerouslySetInnerHTML={{
                              __html: placeholderImage,
                            }}
                          />
                        )}
                      </motion.div>
                    </AnimatePresence>
                  </div>
                )
              )
            })}
            <div className="bg-surface-secondary-default [&>*:not(:last-child)]:border-b [&>*]:p-6 basis-1/2 md:py-8 md:px-[74px] md:[&>*]:pl-0 md:[&>*]:pr-0">
              {accordionItems.map((accordion, i) => {
                const { title, body } = accordion

                return (
                  <Accordion.Item
                    initialOpen={i === 0}
                    key={i}
                    id={i.toString()}
                    title={
                      <Heading
                        variant="title-six"
                        className="md:typography--title-five text-left w-full"
                      >
                        {title}
                      </Heading>
                    }
                    className="!p-0 gap-4"
                  >
                    <Text
                      className="mt-2 md:mr-7"
                      dangerouslySetInnerHTML={{
                        __html: body,
                      }}
                    />
                  </Accordion.Item>
                )
              })}
            </div>
          </>
        )}
      </Accordion>
    </ConditionalWrapper>
  )
}

export default MediaAccordion
